import React, {forwardRef} from 'react';
import {Switch as MuiSwitch} from '@mui/material';
import {makeStyles} from "@mui/styles";
import Switches from "../../../custom/mui_rff/switches";

const useStyles = makeStyles((theme) => ({
    root: {
        width: props => props.size * 9,
        height: props => props.size * 5,
    },
    switchBase: {
        transform: props => `translate(${props.size * 0.5}px, ${props.size * 0.5}px)`,
        '&.Mui-disabled': {
            transform: props => `translate(${props.size * 0.5}px, ${props.size * 0.5}px)`,
            '&.Mui-checked': {
                transform: props => `translate(${props.size * 4.5}px, ${props.size * 0.5}px)`,
            }
        },
        '&.Mui-checked': {
            transform: props => `translate(${props.size * 4.5}px, ${props.size * 0.5}px)`,
        },
    },
    thumb: {
        width: props => props.size * 3.5,
        height: props => props.size * 3.5,
    },
    track: {
        borderRadius: props => props.size * 3.5,
    },
}))


/**
 *
 * @type {React.ForwardRefExoticComponent<React.PropsWithoutRef< Omit<import('@mui/material').SwitchProps, 'onChange'| 'size'> & {
 * readonly onChange?: (boolean) => void,
 * readonly size?: number,
 * }> & React.RefAttributes<HTMLButtonElement>>}
 */
export const Switch = forwardRef(({
                                      onChange,
                                      size = 6,
                                      ...props
                                  }, ref) => {
    const classes = useStyles({size});
    return (
        <MuiSwitch
            ref={ref}
            onChange={(e) => onChange(e.target.checked)}
            classes={{
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
            }}
            {...props}
        />
    );
});

export const SwitchForm = ({
                               value,
                               checked = false,
                               name,
                               required = false,
                               label,
                               helperText,
                               fieldProps,
                               formControlProps,
                               formGroupProps,
                               formLabelProps,
                               formControlLabelProps,
                               formHelperTextProps,
                               labelPlacement = 'start',
                               size = 6,
                               ...props
                           }) => {
    const classes = useStyles({size});
    return (
        <Switches
            required={required}
            data={{value: `${name}`}}
            name={name}
            label={label}
            checked={checked}
            value={value}
            helperText={helperText}
            disableRipple
            classes={{
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
            }}
            formControlLabelProps={{...formControlLabelProps, labelPlacement: labelPlacement}}
            fieldProps={fieldProps}
            formControlProps={formControlProps}
            formGroupProps={formGroupProps}
            formLabelProps={formLabelProps}
            formHelperTextProps={formHelperTextProps}
            fullWidth={false}
            {...props}
        />
    );
};

